import { ReactNode } from 'react';

import { themeColor } from '@scripts/themes/cssVars';

const SubHeading = ({ children }: { children?: ReactNode }) => {
    return (
        <div>
            <p
                css={{
                    color: themeColor.textLight,
                }}
            >
                {children}
            </p>
        </div>
    );
};
export default SubHeading;
